import { getTreasuryProductData, updateTreasuryProductData } from 'actions'
import NotificationError from 'components/common/notificationsErrors'
import InputText from 'components/form/inputText'
import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'
import { Form, Formik, FormikProps } from 'formik'
import { getValidationSchema } from 'lib/FieldValidations'
import {
	IGetTreasuryProductDataParams,
	IGetTreasuryProductDataResponse,
	IUpdateTreasuryProductDataParams
} from 'models/IndividualTreasuryItem'
import React, { Component, Fragment } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Label } from 'reactstrap'
import { ITreasuryProductItemStore } from 'reducers/IndividualTreasuryItem'
import _ from 'underscore'

const noRenderInputs = ['sig_proceso', 'fin_item', 'modif_pcio', 'ind_stock']

interface IndividualTreasuryItemProps extends WithTranslation {
	fields: Array<IFieldStructure>
	product: number
	idOperacion: string
	t?: any
	getTreasuryProductData: (payload: IGetTreasuryProductDataParams) => void
	updateTreasuryProductData: (payload: IUpdateTreasuryProductDataParams) => void
	treasuryProduct: ITreasuryProductItemStore
	handleCloseModal: () => void
}

interface IndividualTreasuryItemState {}

class IndividualTreasuryItem extends Component<
	IndividualTreasuryItemProps,
	IndividualTreasuryItemState
> {
	constructor(props: IndividualTreasuryItemProps) {
		super(props)
		this.state = {}
	}

	componentDidMount = (): void => {
		const { product, idOperacion } = this.props
		this.props.getTreasuryProductData({ idOperacion, nitem: product })
	}

	/**
	 * to show the form fields from the api configuration     *
	 */
	renderFormInputs = (
		formikProps: FormikProps<IGetTreasuryProductDataResponse>
	) => {
		const { fields } = this.props
		const result: any = []

		if (!_.isEmpty(fields)) {
			fields.forEach((field) => {
				const fieldId = field.idCampo.trim()

				if (
					field.editable &&
					field.visible &&
					!noRenderInputs.includes(fieldId)
				) {
					result.push(
						<Col key={field.idCampo}>
							{this.renderInput(field, formikProps)}
						</Col>
					)
				}
			})
		}

		return result
	}

	/**
	 * to show the form fields from the api configuration
	 * @param field
	 * @param value
	 */
	renderInput = (
		field: IFieldStructure,
		formikProps: FormikProps<IGetTreasuryProductDataResponse>
	) => {
		const { values, setFieldValue } = formikProps

		const fieldId = field.idCampo.trim()
		let result = null

		// const inputValue = !_.isEmpty(values) ? values[fieldId] : ''
		// const inputValue = !_.isEmpty(values)
		// 	? values[fieldId as keyof IGetTreasuryProductDataResponse]
		// 	: ''

		const inputValue =
			!_.isEmpty(values) && fieldId in values
				? values[fieldId as keyof IGetTreasuryProductDataResponse]
				: ''

		const optionsInput = {
			inputFormCol: { sm: 12 },
			fields: [{ ...field, label: false }],
			label: field.label,
			inputId: `${fieldId}`,
			id: `${fieldId}`,
			name: `${fieldId}`,
			colLabel: 'col-sm-2',
			colInput: 'col-sm-10',
			divStyle: { paddingLeft: '10px', paddingRight: '10px' },
			disable: false,
			value: inputValue,
			rowStyle: { marginBottom: '5px' },
			onBlur: (data: any) => this.handleOnblurInput(data, fieldId, formikProps),
			onChange: (value: any) => {
				setFieldValue(fieldId, value)
			}
		}

		if (field.editable) {
			result = <InputText {...optionsInput} />
		}

		return result
	}

	/**
	 * To update state data in the onblur event
	 * @params value
	 * @params fieldId
	 * @params row
	 */

	handleOnblurInput = async (
		value: any,
		fieldId: string,
		formikProps: FormikProps<IGetTreasuryProductDataResponse>
	) => {
		const { setFieldValue } = formikProps
		this.setState({ isUpdateRecord: fieldId })
		setFieldValue(fieldId, value)
	}

	/**
	 * to edit a record
	 */
	handleEditItem = (values: IUpdateTreasuryProductDataParams) => {
		const { idOperacion, treasuryProduct } = this.props
		const { data } = treasuryProduct

		this.props.updateTreasuryProductData({
			...values,
			idOperacion,
			niprod: data?.niprod,
			nitem: data?.nitem
		})

		this.props.handleCloseModal()
	}

	/**
	 * get initial data from fields and data from BD
	 * @param data
	 * @param fields
	 * @returns result
	 */
	getInitialValues = (
		data: IGetTreasuryProductDataResponse,
		fields: Array<IFieldStructure>
	) => {
		const result: any = {}

		fields.forEach((field) => {
			const fieldId = field.idCampo
			if (!noRenderInputs.includes(fieldId)) {
				result[fieldId] = data[fieldId as keyof IGetTreasuryProductDataResponse]
			}
		})

		return result
	}

	render() {
		const { fields, t, treasuryProduct } = this.props
		const { data, status } = treasuryProduct

		const validationSchema = !_.isEmpty(fields)
			? getValidationSchema(fields, t, [])
			: {}

		const descProd = status === 'succeeded' ? data?.desc_prod : ''
		if (!_.isEmpty(data) && data !== null) {
			const initialValues = this.getInitialValues(data, fields)
			return (
				<Formik
					initialValues={initialValues}
					onSubmit={(values: any, actions) => {
						this.handleEditItem(values)
					}}
					validationSchema={validationSchema}
					enableReinitialize={true}
					render={(props: FormikProps<IGetTreasuryProductDataResponse>) => {
						return (
							<Fragment>
								<Col sm={12}>
									<NotificationError
										errors={props.errors}
										touched={props.touched}
									/>
								</Col>
								<Form>
									<Row>
										<Col sm={2}>
											<Label style={{ fontSize: '10pt', marginLeft: '28px' }}>
												{'Producto'}
											</Label>
										</Col>
										<Col sm={10}>
											<Label style={{ fontSize: '10pt', marginLeft: '15px' }}>
												{descProd}
											</Label>
										</Col>
									</Row>
									{this.renderFormInputs(props)}
									<Row className={'pt-3'}>
										<Col sm={6} className={'text-center mt-2'}>
											<Button
												style={{ minWidth: '145px' }}
												type={'submit'}
												disabled={!data}
											>
												{t('Collection.form.buttons.accept')}
											</Button>
										</Col>
										<Col sm={6} className={'text-center mt-2'}>
											<Button
												style={{ minWidth: '145px' }}
												type={'button'}
												disabled={!data}
												onClick={this.props.handleCloseModal}
											>
												{t('Collection.form.buttons.cancel')}
											</Button>
										</Col>
									</Row>
								</Form>
							</Fragment>
						)
					}}
				/>
			)
		}
		return <div />
	}
}

const mapStateToProps = ({ individualTreasuryItem }: any) => {
	const { treasuryProduct } = individualTreasuryItem
	return { treasuryProduct }
}

const mapDispatchToProps = {
	getTreasuryProductData,
	updateTreasuryProductData
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(IndividualTreasuryItem))
